const supportedTypes = {
    category: true,
    external: true,
    internal: true
};

const getCategoryPage = ({query}) => ({page: '/category'});
const getVideoCategoryPage = ({query}) => ({page: '/videoCategory'});
const getLifestyleCategoryPage = ({query}) => ({page: '/lifestyleCategory'});
const getInternalPage = (id) => ({page: '/content', query: {id}});

const structureSitemap = (items, parent) => {
    const filtered = items.filter(({type, availableFor = {}}) => supportedTypes[type] && availableFor.desktop !== false);

    filtered.forEach((item) => {
        if (parent) {
            item.parent = parent.categoryId;
        }

        if (item.children) {
            item.children = structureSitemap(item.children, item);
        }
    });

    return filtered;
};

const flattenSitemap = (items) => {
    const flattened = [];

    items.forEach((item) => {
        flattened.push(item);

        if (item.children) {
            flattened.push(...flattenSitemap(item.children));
        }
    });

    return flattened;
};

const compileSitemap = (sitemap, {feature: {video, lifestyle}}) => {
    const compiled = {};
    flattenSitemap(sitemap).forEach((item) => {
        const key = item.fullUrlPath.replace(/^\/|\/$/g, '');
        switch (item.type) {
            case 'category':
                compiled[key] = (() => {
                    if (key.startsWith('video') && video) {
                        return getVideoCategoryPage;
                    }
                    if (key.startsWith('lifestyle') && lifestyle) {
                        return getLifestyleCategoryPage;
                    }
                    return getCategoryPage;
                })();
                break;
            case 'internal':
                compiled[key] = () => getInternalPage(item.metadataID);
                break;
            default:
        }
    });

    return compiled;
};

module.exports = {structureSitemap, flattenSitemap, compileSitemap};
